<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 12 13">
    <g clip-path="url(#clip0_6892_9077)">
      <path
        d="M0.777832 13H4.77783V0H0.777832V13ZM1.77783 1H3.77783V12H1.77783V1ZM7.77783 0V13H11.7778V0H7.77783ZM10.7778 12H8.77783V1H10.7778V12Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9077">
        <rect width="11" height="13" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
